export interface Article {
  id: number;
  title: string;
  author: string;
  category: string;
  categoryName: string;
  excerpt: string;
  content: string;
  coverImage: string;
  wordCount: number;
  reads: number;
  likes: number;
  tags: string[];
  createdAt: string;
  updatedAt: string;
  isFeatured: boolean;
  isHot: boolean;
}

export const articles: Article[] = [
  {
    id: 1,
    title: '夜色中的丝袜倩影',
    author: '月下独酌',
    category: 'dushi-yanqing',
    categoryName: '都市言情',
    excerpt: '那个雨夜，她穿着一双黑色丝袜出现在我面前，从此我的世界便不再平静。都市的霓虹灯下，一段关于丝袜与爱情的故事悄然展开……',
    content: `<p>那是一个闷热的夏日傍晚，天空阴沉沉的，仿佛随时都会落下一场大雨。我坐在公司楼下的咖啡馆里，百无聊赖地搅动着杯中的拿铁，目光漫无目的地扫过窗外匆匆而过的行人。</p>
<p>就在这时，她出现了。</p>
<p>她穿着一件简洁的白色衬衫和一条黑色的包臀短裙，最引人注目的是那双裹在黑色丝袜里的修长双腿。丝袜在夕阳的余晖中泛着若有若无的光泽，每一步都像是在跳一支优雅的舞。</p>
<p>她推门走进咖啡馆，高跟鞋踩在木地板上发出清脆的声响。我下意识地坐直了身子，心跳莫名加快了节奏。</p>
<p>她径直走到柜台前，点了一杯美式咖啡。等待的时候，她转过身来，我们的目光在空中短暂地交汇。她微微笑了笑，那一瞬间，我仿佛看到了整个夏天最明亮的星光。</p>
<p>从那天起，我开始频繁地光顾那家咖啡馆。而她，也总在差不多的时间出现。渐渐地，我们从点头之交变成了可以闲聊的朋友。</p>
<p>她叫林婉儿，是一家广告公司的创意总监。她说自己偏爱丝袜，因为那是女人最温柔的铠甲——既可以展现优雅，又能保护自己。</p>
<p>在一个雨夜，她没有带伞。我鼓起勇气送她回家。雨水打湿了她的丝袜，在路灯下闪烁着碎钻般的光芒。那条路，我们走了很久很久，仿佛走完了一整个青春的时光。</p>
<p>后来，她成了我的女朋友。再后来，她成了我的妻子。</p>
<p>每当我们回忆起相识的那一天，她总会笑着说："你知道吗？那天我是故意走进那家咖啡馆的。因为我在窗外看到了一个傻傻盯着咖啡发呆的男生，觉得他应该需要一个美好的故事。"</p>
<p>而我知道，那个美好的故事，是从一双黑色丝袜开始的。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20in%20black%20stockings%20walking%20through%20rainy%20city%20street%20at%20night%2C%20warm%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20romantic%20atmosphere%2C%20cinematic%20lighting%2C%20soft%20bokeh%20background%2C%20artistic%20photography%20style%2C%20warm%20amber%20tones&width=800&height=500&seq=article-cover-01&orientation=landscape',
    wordCount: 12580,
    reads: 125800,
    likes: 8920,
    tags: ['都市', '爱情', '丝袜', '邂逅'],
    createdAt: '2026-08-10',
    updatedAt: '2026-08-10',
    isFeatured: true,
    isHot: true,
  },
  {
    id: 2,
    title: '校园里的丝袜女孩',
    author: '清风徐来',
    category: 'qingchun-xiaoyuan',
    categoryName: '青春校园',
    excerpt: '大学校园里，她是第一个敢于穿丝袜上课的女生。在那些青涩的岁月里，她用自己的方式，书写了一段关于勇敢与美丽的青春物语……',
    content: `<p>大学开学的第一天，整间教室都因为她而安静了几秒钟。</p>
<p>她穿着一件米白色的针织衫，搭配一条深灰色的百褶短裙，而裙摆下面，是一双包裹在肤色丝袜里的纤细双腿。在那个时候，敢于在大学课堂里穿丝袜的女生并不多。而她，就这样自信地走了进来。</p>
<p>她叫苏小曼，文学院的新生。我是她的同班同学，坐在教室的最后一排。从她进门的那一刻起，我的目光就再也无法从她身上移开了。</p>
<p>起初，班上有些女生在背后议论她，说她太张扬，太爱打扮。但小曼从来不在意这些。她认真上课，积极参加社团活动，门门功课都名列前茅。渐渐地，那些议论声消失了，取而代之的是由衷的敬佩。</p>
<p>大二那年，我和小曼被分到了同一个课题小组。第一次近距离接触，我才发现她比我想象中更加优秀。她的思维敏捷，表达清晰，而且总能在关键时刻提出令人眼前一亮的创意。</p>
<p>有一天晚上，我们为了准备第二天的课题答辩，在图书馆待到了闭馆。一起走出图书馆的时候，秋夜的凉风让她微微打了个寒颤。我脱下外套递给她，她先是愣了一下，然后接过去轻轻披在了肩上。</p>
<p>"你知道吗？"她突然开口，"我穿丝袜并不只是因为好看。"</p>
<p>"那是为什么？"我好奇地问。</p>
<p>"小时候，我妈妈因为一场车祸伤了腿，留下了很深的疤痕。从那以后，她再也没有穿过裙子。后来我长大了，我就告诉自己，我要替妈妈穿上所有她不敢穿的衣服，带着她的那份美丽，自信地活在这个世界上。"</p>
<p>那一刻，月光洒在她裹着丝袜的腿上，我第一次觉得，原来美丽可以如此动人，如此深刻。</p>
<p>后来，我们在一起了。毕业后，我带着小曼回了家。妈妈看到小曼的第一眼，眼眶就红了。那天晚上，妈妈翻出了压在箱底二十年的那条裙子，轻轻地穿在了身上。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20college%20girl%20in%20stockings%20walking%20on%20campus%20path%20under%20autumn%20cherry%20blossom%20trees%2C%20soft%20sunlight%20filtering%20through%20leaves%2C%20warm%20golden%20hour%20lighting%2C%20nostalgic%20atmosphere%2C%20film%20photography%20aesthetic&width=800&height=500&seq=article-cover-02&orientation=landscape',
    wordCount: 9820,
    reads: 98700,
    likes: 7560,
    tags: ['校园', '青春', '成长', '感人'],
    createdAt: '2026-08-09',
    updatedAt: '2026-08-09',
    isFeatured: true,
    isHot: true,
  },
  {
    id: 3,
    title: '办公室的丝袜情缘',
    author: '城市浪子',
    category: 'zhichang-qinggan',
    categoryName: '职场情感',
    excerpt: '她是公司里所有男同事心中的女神，笔挺的职业装搭配精致的丝袜，举手投足间尽显职场女性的魅力。而我，一个普通的新人，却意外闯入了她的世界……',
    content: `<p>入职的第一天，我就听说了她的大名——沈清漪，市场部总监，公司的传奇人物。</p>
<p>同事们说她三十岁不到就坐上了总监的位置，靠的不是关系，而是实打实的业绩。他们说她是冰美人，对谁都礼貌而疏离，从不参加任何同事聚会。</p>
<p>我第一次见到她，是在电梯里。她穿着一套剪裁得体的深蓝色西装套裙，肉色丝袜包裹的双腿笔直修长，脚踩一双黑色高跟鞋。她手里拿着一杯咖啡，目光专注地看着电梯里的楼层显示屏。我站在她旁边，大气都不敢出。</p>
<p>电梯到了十二楼，她走了出去。我这才发现她掉了一张门禁卡。我捡起来追了出去，喊了一声："沈总，您的卡掉了。"</p>
<p>她回过头来，那一瞬间，我看到她眼中的疲惫——那种被太多目光注视、太多责任压着的疲惫。她接过卡，淡淡地说了声谢谢，然后转身走进了办公室。</p>
<p>后来我才知道，原来她不是冰美人。她只是太累了。</p>
<p>作为市场部的新人，我很快就被分配到了她的团队。工作比我想象中辛苦得多，但她对下属的要求严格却又公正，从不让我们背锅。慢慢地，我对她多了一份敬意，也多了一份说不清道不明的情愫。</p>
<p>有一次加班到深夜，办公室里只剩下我们两个人。她脱了高跟鞋，赤脚踩在地毯上，丝袜在昏黄的灯光下泛着柔和的光。她靠在椅子上，闭着眼睛，脸上是掩饰不住的疲倦。</p>
<p>我给她倒了一杯热水，放在她手边。她睁开眼，看着我，第一次露出了不带职业面具的笑容。</p>
<p>"你很像年轻时候的我，"她说，"不过比我那时候更努力，也更傻。"</p>
<p>那个夜晚，我们聊了很久。聊工作，聊理想，聊那些被现实磨平棱角却依然闪烁的梦想。窗外，城市的灯火如星河般璀璨。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20professional%20woman%20in%20stockings%20and%20business%20suit%20sitting%20at%20modern%20office%20desk%2C%20warm%20ambient%20lighting%20from%20desk%20lamp%2C%20city%20skyline%20visible%20through%20large%20window%20at%20night%2C%20sophisticated%20corporate%20aesthetic&width=800&height=500&seq=article-cover-03&orientation=landscape',
    wordCount: 15800,
    reads: 153200,
    likes: 10230,
    tags: ['职场', '办公室', '情感', '都市'],
    createdAt: '2026-08-08',
    updatedAt: '2026-08-10',
    isFeatured: true,
    isHot: true,
  },
  {
    id: 4,
    title: '穿越千年的丝袜情',
    author: '烟雨江南',
    category: 'gufeng-yanqing',
    categoryName: '古风言情',
    excerpt: '她从现代穿越到古代，随身携带的只有一双丝袜。在那个长裙曳地的年代，这双丝袜成了她与这个时空最奇妙的连接……',
    content: `<p>温若水醒来的时候，发现自己躺在一张古色古香的雕花大床上。头顶是绣着鸳鸯戏水图案的帐幔，鼻尖萦绕着淡淡的檀香味。</p>
<p>她花了整整三天时间才接受这个事实——她穿越了，穿越到了一个她从未在历史书上见过的朝代。</p>
<p>幸运的是，她穿越到了一个大户人家的小姐身上。不幸的是，这位小姐似乎并不受宠，被安排住在府邸最偏僻的角落里。</p>
<p>温若水翻遍了自己的随身物品，发现唯一跟着她穿越过来的，是一双黑色的丝袜——那是她穿越前刚买的，还没来得及穿。</p>
<p>这个时代的女子，裙摆都长得拖地，根本看不到腿。但温若水却想：穿在里面，又没人看到，有什么关系呢？</p>
<p>于是，她成了这个朝代第一个穿丝袜的女子。</p>
<p>有一天，她在后花园散步的时候，不小心崴了脚。裙摆翻起来，露出了一小截裹着丝袜的小腿。恰巧路过的太子萧景琰看到了这一幕。</p>
<p>他的目光在她的小腿上停留了片刻，然后走上前来："姑娘的……袜子，很是别致。"</p>
<p>温若水吓了一跳，连忙把裙摆放下来。但她很快冷静下来，心想：反正是穿越过来的，大不了就说是西域进贡的新奇物件。</p>
<p>"回太子殿下，这是民女家乡的一种织物，轻薄透气，穿着舒适。"</p>
<p>萧景琰若有所思地点了点头。从那以后，他开始频繁地"偶遇"温若水。一开始是真的偶遇，后来……谁也说不清是偶遇还是刻意了。</p>
<p>在一次宫宴上，温若水不慎被热茶泼到了腿上。萧景琰几乎是本能地挡在了她面前，用自己的衣袖护住了她。</p>
<p>"太子殿下，您的袖子……"</p>
<p>"无妨。"他低头看着她，眼中是从未有过的温柔，"你的腿没烫到吧？"</p>
<p>那一刻，温若水知道了——并不是只有丝袜穿越了千年。还有一份跨越时空的爱，也跟着她一起来了。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20ancient%20Chinese%20woman%20in%20traditional%20hanfu%20dress%20standing%20in%20classical%20garden%20with%20pavilion%2C%20soft%20morning%20mist%2C%20peach%20blossoms%2C%20romantic%20historical%20fantasy%20atmosphere%2C%20warm%20vintage%20tones%2C%20ethereal%20lighting&width=800&height=500&seq=article-cover-04&orientation=landscape',
    wordCount: 11450,
    reads: 112300,
    likes: 8450,
    tags: ['穿越', '古风', '宫廷', '爱情'],
    createdAt: '2026-08-07',
    updatedAt: '2026-08-09',
    isFeatured: false,
    isHot: true,
  },
  {
    id: 5,
    title: '丝袜背后的秘密',
    author: '暗夜行者',
    category: 'xuanyi-tuili',
    categoryName: '悬疑推理',
    excerpt: '一条破了的丝袜，一桩离奇的命案。私家侦探陆远在调查这起看似简单的案件时，却一步步揭开了一个关于丝袜的惊天秘密……',
    content: `<p>凌晨三点，陆远的手机响了。</p>
<p>电话是老搭档周警官打来的："老陆，城东别墅区，出了命案。现场有一条丝袜，我觉得你应该来看看。"</p>
<p>陆远赶到现场的时候，天还没亮。死者是一名年轻女性，身着睡衣，左腿上穿着一条黑色的丝袜，右腿却是光着的。丝袜在大腿内侧有一道整齐的裂口，不像是挣扎造成的，更像是被人用剪刀剪开的。</p>
<p>"法医怎么说？"陆远蹲下来仔细观察。</p>
<p>"初步判断死亡时间在晚上十一点到凌晨一点之间。死因是窒息。身上没有其他外伤。"周警官顿了顿，"最诡异的是，整栋别墅里只有她一个人的指纹。"</p>
<p>陆远站起来，环顾四周。别墅装修豪华，但总给人一种不真实的感觉——像是精心布置的舞台，而不是真正有人生活的地方。</p>
<p>调查很快就遇到了瓶颈。死者叫白薇，三十二岁，自由职业者。社会关系简单得不像话：没有男朋友，没有密友，和父母的联系也仅限于每月一次的例行电话。她就像是一个透明人，存在过，却从未真正生活过。</p>
<p>转机出现在第三天。陆远在死者的电脑里发现了一个加密文件夹。破解密码后，里面是上百张照片——都是丝袜。各种各样的丝袜，黑色、肉色、灰色，有花纹的、有蕾丝的、有网眼的。每一张照片都有详细的标注：购买日期、品牌、价格，以及……穿过的次数。</p>
<p>陆远继续往下翻，发现了一个更加令人震惊的秘密……</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Mysterious%20atmosphere%20with%20a%20pair%20of%20torn%20black%20stockings%20on%20wooden%20floor%2C%20dim%20warm%20lighting%2C%20noir%20film%20aesthetic%2C%20shadows%20and%20light%20creating%20suspense%2C%20dark%20academia%20style%2C%20moody%20ambiance&width=800&height=500&seq=article-cover-05&orientation=landscape',
    wordCount: 18700,
    reads: 167800,
    likes: 11340,
    tags: ['悬疑', '推理', '侦探', '秘密'],
    createdAt: '2026-08-06',
    updatedAt: '2026-08-10',
    isFeatured: false,
    isHot: true,
  },
  {
    id: 6,
    title: '都市夜归人的丝袜日记',
    author: '午夜咖啡',
    category: 'xiandai-dushi',
    categoryName: '现代都市',
    excerpt: '每天晚上十点，她都会穿上那条黑色丝袜，走进城市最深处的夜色。白天的她是朝九晚五的上班族，夜晚的她则拥有一个不为人知的身份……',
    content: `<p>每天傍晚六点，顾念念准时下班。她会在公司楼下的便利店买一份便当，回到租住的小公寓，吃完，然后小睡两个小时。</p>
<p>晚上九点，闹钟响起。她起床，洗漱，化妆，然后从衣柜最深处拿出那条黑色丝袜——那不是普通的丝袜，而是她花了三个月工资买的，来自意大利手工制作的顶级丝袜。</p>
<p>穿上丝袜的那一刻，她就不再是白天的顾念念了。她变成了 Nora——城市里最受欢迎的爵士酒吧的驻场钢琴师。</p>
<p>没有人知道 Nora 的真名叫顾念念，也没有人知道顾念念就是 Nora。白天，她是广告公司里默默无闻的小文案。晚上，她是舞台上闪耀的爵士女神，穿着黑色丝袜的双腿在钢琴踏板之间优雅地移动，指尖流淌出的旋律能让整个酒吧的客人为之沉醉。</p>
<p>她喜欢这种双重身份带来的奇妙感觉。就像丝袜一样——看似轻薄透明，实则有着惊人的韧性。</p>
<p>直到有一天，公司的新任创意总监走进了那家爵士酒吧。</p>
<p>他看到了舞台上穿着丝袜弹琴的 Nora，然后，他认出了那是白天坐在工位上从不说话的顾念念。</p>
<p>第二天早上，顾念念在茶水间遇到了他。</p>
<p>"早啊，Nora。"他端着咖啡，嘴角带着意味深长的笑容。</p>
<p>顾念念手中的杯子差点掉在地上。但她深吸了一口气，然后，平生第一次在白天露出了 Nora 才有的自信微笑。</p>
<p>"早啊，总监。不过在这里，你可以叫我顾念念。"</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Woman%20in%20black%20stockings%20playing%20piano%20in%20a%20dimly%20lit%20jazz%20bar%2C%20warm%20spotlight%20on%20the%20pianist%2C%20intimate%20atmospheric%20setting%2C%20smoke%20and%20amber%20lighting%2C%20sophisticated%20nightlife%20aesthetic%2C%20artistic%20composition&width=800&height=500&seq=article-cover-06&orientation=landscape',
    wordCount: 13500,
    reads: 141500,
    likes: 9780,
    tags: ['都市', '双面人生', '音乐', '自我'],
    createdAt: '2026-08-05',
    updatedAt: '2026-08-10',
    isFeatured: true,
    isHot: false,
  },
  {
    id: 7,
    title: '那年夏天的丝袜约定',
    author: '夏日微风',
    category: 'qingchun-xiaoyuan',
    categoryName: '青春校园',
    excerpt: '高三那年，她和闺蜜约定：高考结束那天，一起穿上人生中第一双丝袜。这个简单的约定，成了她们青春岁月里最闪亮的记忆……',
    content: `<p>高考倒计时牌上的数字一天天变小，从三位数变成了两位数，最后停在了个位数上。整个高三楼里弥漫着一种奇特的氛围——紧张、期待，还有一丝即将离别的伤感。</p>
<p>林小雨和周欣然是从小一起长大的闺蜜。她们从幼儿园开始就是同桌，一直到高三。十八年的友谊，比很多人的婚姻还要长久。</p>
<p>"高考结束那天，我们一起穿丝袜吧。"周欣然在一个晚自习后突然说。</p>
<p>"啊？"林小雨愣了一下。</p>
<p>"我妈说，丝袜是女孩子长大的标志。"周欣然眼睛亮晶晶的，"高考之后，我们就是大人了。我想和你一起，穿上人生中的第一双丝袜。"</p>
<p>林小雨想了想，然后重重地点了点头："好，一言为定！"</p>
<p>"一言为定！"</p>
<p>她们还拉了勾。那是属于十八岁少女最简单也最郑重的仪式。</p>
<p>高考那三天，下了一场绵绵的雨。走出考场的那一刻，天空突然放晴了。阳光穿过云层洒下来，在湿润的地面上投下斑驳的光影。</p>
<p>林小雨和周欣然如约在学校的梧桐树下见面。她们都穿上了新买的裙子，还有一双崭新的肉色丝袜。</p>
<p>"你看起来……像个大人了。"林小雨看着周欣然，眼眶有点红。</p>
<p>"你也一样。"周欣然笑了，然后伸出了手，"走吧，不管以后去哪里，我们都说好了——每年今天，都要一起穿丝袜。"</p>
<p>那一年，她们一个去了北京，一个留在了家乡。从此天南海北，见面的机会越来越少。但每年的六月初八，她们都会穿上丝袜，拍一张照片发给对方。</p>
<p>这一约，就是十年。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20young%20girls%20in%20school%20uniforms%20standing%20under%20a%20large%20tree%20on%20sunny%20campus%20after%20rain%2C%20warm%20sunlight%2C%20nostalgic%20summer%20atmosphere%2C%20golden%20hour%20glow%2C%20coming%20of%20age%20theme%2C%20soft%20film%20look&width=800&height=500&seq=article-cover-07&orientation=landscape',
    wordCount: 8920,
    reads: 89600,
    likes: 7230,
    tags: ['校园', '闺蜜', '约定', '成长'],
    createdAt: '2026-08-04',
    updatedAt: '2026-08-08',
    isFeatured: false,
    isHot: true,
  },
  {
    id: 8,
    title: '总裁的丝袜助理',
    author: '星光点点',
    category: 'zhichang-qinggan',
    categoryName: '职场情感',
    excerpt: '她是总裁身边最得力的助理，永远穿着最得体的职业装和丝袜。所有人都以为她只是一个花瓶，直到一场危机让所有人看到了她真正的实力……',
    content: `<p>在恒远集团，有一个不成文的规矩——永远不要小看总裁办的女助理。</p>
<p>尤其是秦晓染。</p>
<p>她今年二十六岁，在总裁身边已经工作了三年。每天早上八点半，她会准时出现在总裁办公室，手里端着一杯温度刚刚好的蓝山咖啡，身上永远穿着剪裁完美的职业套裙，搭配与服装颜色相呼应的丝袜——灰色西装配烟灰色丝袜，米色套装配肤色丝袜，深蓝色连衣裙配黑色丝袜。</p>
<p>公司的男同事们私下叫她"丝袜助理"。他们觉得她只是靠外表才坐上了那个位置。女同事们则在背后酸溜溜地说她不过是命好，傍上了总裁这棵大树。</p>
<p>秦晓染从来不在意这些议论。她知道自己是谁，也知道自己做了什么。</p>
<p>转折发生在公司遭遇最大危机的那一天。</p>
<p>恒远集团最大的客户突然宣布终止合作，消息一出，股价暴跌，公司上下陷入一片混乱。总裁沈墨辰召开了紧急董事会，但所有方案都像是杯水车薪。</p>
<p>就在所有人都焦头烂额的时候，秦晓染默默地从公文包里拿出了一份文件。</p>
<p>"沈总，一周前我在整理客户资料时，发现了一些异常数据。"她的声音平静而笃定，"我私自做了一些调查，发现我们的客户在和竞争对手秘密接触。所以我提前准备了应对方案，包括三个可能的新合作伙伴和两套危机公关策略。"</p>
<p>会议室里安静了整整十秒钟。</p>
<p>沈墨辰翻阅着那份文件，眼中的震惊越来越明显。文件内容详细、严谨、极具可操作性。这不是一个助理能做出的东西——这是一个顶尖商业人才的作品。</p>
<p>"秦助理，"沈墨辰放下文件，看着她的眼神第一次有了真正的尊重，"你是什么时候开始准备的？"</p>
<p>"一个月前，沈总。"秦晓染微微一笑，丝袜包裹的双腿在会议桌下轻轻交叠，"一个好的助理，应该总比老板多想一步。"</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Confident%20professional%20woman%20in%20elegant%20business%20suit%20and%20stockings%20standing%20in%20modern%20corporate%20boardroom%2C%20floor%20to%20ceiling%20windows%20showing%20city%20view%2C%20warm%20natural%20lighting%2C%20powerful%20yet%20graceful%20presence%2C%20sophisticated%20interior%20design&width=800&height=500&seq=article-cover-08&orientation=landscape',
    wordCount: 16200,
    reads: 178900,
    likes: 12450,
    tags: ['职场', '女强人', '总裁', '反转'],
    createdAt: '2026-08-03',
    updatedAt: '2026-08-10',
    isFeatured: true,
    isHot: true,
  },
  {
    id: 9,
    title: '古镇丝袜情',
    author: '水墨江南',
    category: 'gufeng-yanqing',
    categoryName: '古风言情',
    excerpt: '她是一位在古镇经营民宿的现代女子，他是一位前来写生的画家。一条丝袜，一座古镇，一段不期而遇的爱情……',
    content: `<p>周庄的清晨，是从船桨划破水面开始的。</p>
<p>苏念的民宿就开在双桥旁边，推开窗就能看到小桥流水。她在这里已经住了三年，从一个被都市压得喘不过气的上班族，变成了一个会泡茶、会插花、会做桂花糕的民宿老板娘。</p>
<p>那天，店里来了一位特殊的客人。</p>
<p>他背着一个巨大的画板，穿着一件沾了颜料的白衬衫，头发有些凌乱，但眼睛很亮。他站在门口，看着苏念，愣了好几秒钟。</p>
<p>"还有房间吗？"他问。</p>
<p>"有的。"苏念低头看了一眼自己的穿着——一条碎花连衣裙，配了一双肤色的丝袜。在古镇这种地方，穿丝袜的人并不多，但她习惯了。丝袜让她觉得精致，即使在最悠闲的日子里，也要做一个精致的女子。</p>
<p>他叫陆知远，是一位自由画家。他说他来这里是为了画一组关于"水乡女子"的系列作品。</p>
<p>第二天早上，苏念在院子里浇花的时候，陆知远拿着画板走了出来。他的目光又一次落在了她的丝袜上。</p>
<p>"我能画你吗？"他问得很直接。</p>
<p>"为什么要画我？"</p>
<p>"因为你很特别。"他认真地说，"在这个古老的地方，你穿着现代的东西，却一点都不违和。你的丝袜和这座古镇，有一种奇妙的和谐。"</p>
<p>苏念想了想，答应了。</p>
<p>就这样，他们开始了每天早晨的"写生时间"。陆知远画画的时候很专注，苏念就静静地坐在那里，有时看书，有时发呆，有时和他聊天。</p>
<p>画到第七天的时候，苏念发现陆知远的画板上不再是她的全身像，而是一双穿着丝袜的腿——线条柔和，光影细腻，充满了温柔。</p>
<p>"这是我画过的最美的东西。"陆知远说。</p>
<p>苏念的脸红了。在古镇住了三年，她第一次觉得，也许有些东西，比岁月静好更让人心动。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20in%20floral%20dress%20and%20stockings%20sitting%20by%20ancient%20water%20town%20canal%20bridge%2C%20traditional%20Chinese%20architecture%2C%20morning%20mist%20over%20water%2C%20peaceful%20atmosphere%2C%20warm%20sunlight%2C%20romantic%20artistic%20vibe&width=800&height=500&seq=article-cover-09&orientation=landscape',
    wordCount: 10400,
    reads: 95600,
    likes: 8120,
    tags: ['古镇', '画家', '民宿', '文艺'],
    createdAt: '2026-08-02',
    updatedAt: '2026-08-09',
    isFeatured: false,
    isHot: false,
  },
  {
    id: 10,
    title: '丝袜迷局',
    author: '暗夜行者',
    category: 'xuanyi-tuili',
    categoryName: '悬疑推理',
    excerpt: '五年前的一起悬案，唯一的物证就是一条丝袜。当相似的案件再次发生，警探方宇知道，那个丝袜杀手，又回来了……',
    content: `<p>方宇接到电话的时候，正在整理五年前的卷宗。</p>
<p>那是他职业生涯中唯一一桩没能侦破的案件——"丝袜连环杀人案"。凶手会在每名受害者的左腿上穿一条全新的黑色丝袜，右腿则保持原样。这个诡异的作案手法让整个警局的人都印象深刻。</p>
<p>五年前，案件在最关键的时候突然中断了。所有的线索都指向了一个人，但那个人却在一场车祸中丧生。没有结案报告，没有真相，只有一个永远无法解开的谜。</p>
<p>直到今天。</p>
<p>"方队，城南废弃工厂发现一具女尸。现场的情况……和五年前的丝袜案一模一样。"</p>
<p>方宇只觉得后背一阵发凉。他放下卷宗，抓起外套冲出了办公室。</p>
<p>现场被封锁得严严实实。方宇蹲在尸体旁边，目光死死地盯着那条黑色的丝袜——品牌、颜色、甚至是裂口的位置，都和五年前如出一辙。</p>
<p>但这不可能。那个嫌疑人已经死了。</p>
<p>除非……</p>
<p>方宇猛地站了起来。他想起了一个被所有人忽略的细节——五年前的案卷中，有一条不起眼的记录：嫌疑人的妹妹，在他死后第二天搬离了这座城市。</p>
<p>方宇立刻让人调出了那名妹妹的资料。照片上的女人长相普通，戴着一副黑框眼镜，看起来毫不起眼。但方宇注意到了她的眼神——那是一种猎人才有的眼神，冷静、专注，还有一丝难以掩饰的兴奋。</p>
<p>"找到她。"方宇说，"不惜一切代价，找到她。"</p>
<p>与此同时，城市另一端的某个地下室里，一个女人正在对着镜子，慢慢地穿上一条黑色的丝袜。她的嘴角带着一抹意味深长的微笑。</p>
<p>"哥哥，"她轻声说，"你的作品，我来帮你完成。"</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20crime%20scene%20aesthetic%20with%20police%20tape%2C%20a%20single%20black%20stocking%20on%20the%20ground%2C%20dim%20industrial%20lighting%2C%20noir%20film%20atmosphere%2C%20shadows%20creating%20tension%2C%20warm%20yet%20ominous%20tones&width=800&height=500&seq=article-cover-10&orientation=landscape',
    wordCount: 20100,
    reads: 189500,
    likes: 13500,
    tags: ['悬疑', '连环案', '警探', '复仇'],
    createdAt: '2026-08-01',
    updatedAt: '2026-08-10',
    isFeatured: true,
    isHot: true,
  },
  {
    id: 11,
    title: '咖啡店里的丝袜女生',
    author: '月下独酌',
    category: 'dushi-yanqing',
    categoryName: '都市言情',
    excerpt: '每天下午三点，她都会准时出现在街角的咖啡店，点一杯拿铁，坐在靠窗的位置。她总是穿着不同颜色的丝袜，像一道流动的风景线……',
    content: `<p>我在那条街开了五年咖啡店，见过形形色色的客人。但她是唯一一个让我记住的。</p>
<p>每天下午三点，她都会准时推门进来。周一是黑色丝袜配深蓝连衣裙，周二是肤色丝袜配米色套装，周三是灰色丝袜配烟粉色风衣，周四……总之，每一天都有不同的搭配。</p>
<p>她的名字叫什么，我不知道。她在哪里上班，我不知道。她为什么每天都要换不同颜色的丝袜，我也不知道。</p>
<p>我只知道，她成了我咖啡店里最美丽的风景。</p>
<p>三个月后，我终于鼓起勇气和她说了第一句话。</p>
<p>"今天的美式少放点冰？我看你昨天那杯没喝完。"</p>
<p>她抬起头看着我，目光中有些意外，然后笑了："你注意到了？"</p>
<p>"我是咖啡师嘛，习惯了。"我嘴上这么说，心里却在想——岂止是注意到，我连你周一穿什么颜色的丝袜都记得一清二楚。</p>
<p>从那天开始，我们偶尔会聊几句。我知道了她叫乔一诺，在附近的设计公司做平面设计。她喜欢丝袜，是因为她觉得丝袜可以给每一天赋予不同的色彩和心情。</p>
<p>"周一是黑色，因为要面对一周中最多的会议。"她说，"周三是灰色，不上不下的一天，需要一些中性的力量。周五是带点花纹的，因为马上就是周末了。"</p>
<p>我听得入了神。原来在她眼中，丝袜不只是配饰，而是一种生活方式。</p>
<p>有一天，她突然问我："你会调酒吗？"</p>
<p>"会一点。"</p>
<p>"那你会不会调一杯……以丝袜为主题的鸡尾酒？"</p>
<p>我愣了一下，然后笑了："给我三天时间。"</p>
<p>三天后，我为她调了一杯名为"丝袜"的特调。底酒用了伏特加，加入了黑加仑利口酒赋予它深邃的紫黑色，表面浮着一层薄薄的奶泡——像极了丝袜包裹肌肤时的那种若隐若现。</p>
<p>她喝了一口，眼睛亮了起来。</p>
<p>"这杯酒……像极了我的人生。"</p>
<p>"也是你给我的灵感。"我说。</p>
<p>那天晚上，她留到了打烊。我们一起洗杯子，一起擦桌子，一起锁门。走出咖啡店的时候，天空下起了小雨，她穿着黑色丝袜的双腿在路灯下闪烁着水光。</p>
<p>我撑起伞，她自然地靠了过来。那一刻，我闻到了她发间的栀子花香。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=A%20woman%20in%20stockings%20sitting%20by%20the%20window%20of%20a%20cozy%20coffee%20shop%2C%20warm%20afternoon%20sunlight%20streaming%20through%20glass%2C%20steaming%20coffee%20cup%20on%20wooden%20table%2C%20romantic%20urban%20atmosphere%2C%20soft%20golden%20lighting%2C%20artistic%20lifestyle%20photography&width=800&height=500&seq=article-cover-11&orientation=landscape',
    wordCount: 11300,
    reads: 107800,
    likes: 8920,
    tags: ['咖啡店', '邂逅', '日常', '浪漫'],
    createdAt: '2026-07-31',
    updatedAt: '2026-08-08',
    isFeatured: false,
    isHot: true,
  },
  {
    id: 12,
    title: '最后一个穿丝袜的女人',
    author: '城市浪子',
    category: 'xiandai-dushi',
    categoryName: '现代都市',
    excerpt: '在未来世界，丝袜已经被高科技取代。她是最后一个坚持穿传统丝袜的女人，她的坚持，让一个时代记忆得以延续……',
    content: `<p>2045年，丝袜已经成为历史。</p>
<p>自从"肌肤衣"面世以来，传统的丝袜就在短短三年内被彻底淘汰。这种高科技产品可以直接喷涂在皮肤上，形成一层比丝袜更轻薄、更透气、更耐用的保护膜。而且它还能根据环境自动调节温度——夏天清凉，冬天保暖。</p>
<p>没有人再穿丝袜了。除了她。</p>
<p>叶知秋今年三十五岁，在一家文化遗产保护机构工作。每天清晨，她都会打开那个已经停产的老式丝袜品牌的最后一个库存抽屉，从中拿出一双丝袜，小心翼翼地穿上。</p>
<p>她家里储存了整整一个房间的丝袜——那是她在品牌倒闭前一次性买下的。按每天穿一双计算，足够她穿二十年。</p>
<p>"你为什么要穿这种东西？"同事们总是这样问她，"又麻烦又容易破损，肌肤衣多好，喷一喷就行了。"</p>
<p>叶知秋从不解释。她只是微笑着，继续穿着她的丝袜，走在城市的街头。那些匆忙的行人偶尔会多看她一眼——看到一个执着于旧时代审美的奇怪女人。</p>
<p>直到有一天，一家时尚杂志的记者发现了她。</p>
<p>"你为什么还在穿丝袜？"记者问。</p>
<p>叶知秋沉默了很久，然后说："因为我妈妈。"</p>
<p>"你的妈妈？"</p>
<p>"我妈妈是一个丝袜设计师。她一辈子都在设计丝袜，从十七岁到五十七岁，整整四十年。肌肤衣出现的那一年，她失去了工作，也失去了活着的意义。"叶知秋的声音很轻，像是在回忆很久远的事情，"她去世前和我说，丝袜不只是一件衣物，它代表着一个时代女性对美的追求。每一根丝线的交织，都是那个时代独一无二的注脚。总要有人记住它。"</p>
<p>"所以，你成了那个人。"</p>
<p>"是的。"叶知秋低头看着自己裹在丝袜里的双腿，"我成了最后一个穿丝袜的女人。"</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Futuristic%20city%20street%20with%20a%20woman%20in%20classic%20black%20stockings%20walking%20among%20modern%20architecture%2C%20contrast%20between%20retro%20and%20futuristic%2C%20warm%20sunset%20lighting%2C%20nostalgic%20yet%20modern%20atmosphere%2C%20cinematic%20composition&width=800&height=500&seq=article-cover-12&orientation=landscape',
    wordCount: 9700,
    reads: 88700,
    likes: 7650,
    tags: ['未来', '传承', '母亲', '怀旧'],
    createdAt: '2026-07-30',
    updatedAt: '2026-08-07',
    isFeatured: false,
    isHot: false,
  },
];